import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText } from "../../utils";

export default {
    title: "Utility/Link Wrapper",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-link-wrapper",
    args: { target: "_self" },
    argTypes: {
        target: {
            control: { type: "radio" },
            options: ["_blank", "_self", "_parent", "_top", "_unfencedTop"],
        },
    },
};

const Template = ({ target }) =>
    html` <ux-iws-link-wrapper class="ux-iws-teaser-page">
        <div class="ux-iws-teaser-page__container">
            <div class="ux-iws-teaser-page__inner">
                <span
                    data-ux-iws-link-wrapper-ignore
                    class="ux-tag ux-iws-teaser-page__tag"
                >
                    category
                </span>
                <p class="ux-iws-teaser-page__title ux-text-headline">
                    <a
                        class="ux-iws-teaser-page__link"
                        target="${target}"
                        href="#321"
                    >
                        Headline
                    </a>
                </p>
                <ux-text-lines-limit text-lines="3">
                    <p class="ux-iws-teaser-page__description">
                        ${getDummyText(400)}
                    </p>
                </ux-text-lines-limit>
            </div>
            <div class="ux-iws-teaser-page__link">
                <a
                    class="ux-button ux-button--icon-only"
                    href="#321"
                    aria-label="Lorem Ipsum"
                    role="button"
                    target="${target}"
                >
                    <ux-icon name="chevron-right"> </ux-icon>
                </a>
            </div>
        </div>
    </ux-iws-link-wrapper>`;

export const Default = Template.bind({});
Default.args = {
    target: "_blank",
};
Default.argTypes = {
    control: { type: "radio" },
    options: ["_blank", "_self", "_parent", "_top", "_unfencedTop"],
};
